import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {SignatureCanvas} from "../SignatureCanvas/SignatureCanvas";
import "./SignatureDrawing.scss"
import {useIsMobileDevice} from "../../../../hooks/useIsMobileDevice";
import SignaturePad from "signature_pad";
import closeIcon from "../../../../assets/icons/times-solid.svg";

interface SignatureDrawingProps {
    onSetSignatureImageData: (imageData: ImageData) => void;
    clearFlag: boolean;
    canvasWidth: number;
}

export const SignatureDrawing: React.FunctionComponent<SignatureDrawingProps> = (props) => {
    const [signatureCanvasContext, setSignatureCanvasContext] = useState<CanvasRenderingContext2D>();
    const [signatureCanvas, setSignatureCanvas] = useState<HTMLCanvasElement>();
    const signaturePreview = useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;
    const isMobile = useIsMobileDevice(false);
    const [signaturePad, setSignaturePad] = useState<SignaturePad>();

    useEffect(() => {
        if (isMobile) {
            hidePreviewElement();
        }
    }, [isMobile]);

    useEffect(() => {
        if (props.clearFlag && signaturePad) {
            signaturePad.clear();
        }
    }, [props.clearFlag]);

    const hidePreviewElement = () => {
        signaturePreview.current.style.display = 'none';
    }

    const getSignatureCanvasContext = (initSignatureCanvasContext: CanvasRenderingContext2D, initSignatureCanvas: HTMLCanvasElement) => {
        setSignatureCanvasContext(initSignatureCanvasContext);
        setSignatureCanvas(initSignatureCanvas);
        const signaturePad = new SignaturePad(initSignatureCanvas, {
            penColor: '#0a0a0a',
            minWidth: 1,
            maxWidth: 2,
        });
        signaturePad.addEventListener('beginStroke', () => {
            hidePreviewElement();
        });
        setSignaturePad(signaturePad);
    }

    const updateImageData = () => {
        props.onSetSignatureImageData((signatureCanvasContext as CanvasRenderingContext2D).getImageData(0, 0, (signatureCanvas as HTMLCanvasElement).width, (signatureCanvas as HTMLCanvasElement).height))
    }

    return (<div className={'drawing-signature'}>
        <div ref={signaturePreview}
             className={'signature-preview'}/>
        <div className={'signature'}>
            <SignatureCanvas canvasWidth={props.canvasWidth} onMouseLeave={() => {
                updateImageData()
            }} onTouchCancel={() => {
                updateImageData();
            }} onMouseUp={() => {
                updateImageData();
            }} onTouchEnd={() => {
                updateImageData();
            }} onMouseDown={() => {
                hidePreviewElement();
            }}
                             getSignatureCanvasContext={getSignatureCanvasContext}/>
            <div className="signature-input-outlet">
                <img className='image-icon clickable signature-input-outlet-icon' src={closeIcon} alt="close"/>
            </div>
        </div>
    </div>)
}
